// extracted by mini-css-extract-plugin
export default {"container":"VerifyStep_container__j4WtY","inputList":"VerifyStep_inputList__lfIMv","button":"VerifyStep_button__ISVyZ"};